export var EColumnAggregationLimit;
(function (EColumnAggregationLimit) {
    EColumnAggregationLimit["Currency"] = "currency";
    EColumnAggregationLimit["NoLimit"] = "noLimit";
    EColumnAggregationLimit["Underlying"] = "underlying";
})(EColumnAggregationLimit || (EColumnAggregationLimit = {}));
